export default "__VITE_ASSET__DCrt3qtT__"